import React, { useState, useRef, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../VisitReportFrame';
//import-start
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Toggle, { TOGGLE_STATES } from '../../../Toggle';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import useAuthAxios from "../../../../useAuthAxios";
import InspectionPreviewDialog from "../../Warranty/InspectionPreviewDialog" //TODO:定期点検のファイルを参照で良いか
import InspectionDeleteDialog from "../../Warranty/InspectionDeleteDialog.js" //TODO:定期点検のファイルを参照で良いか
import { alpha } from '@mui/material/styles';

import {
    NomalButton,
} from '../../../css/CSS.js';
//import-end

export default function InsFormFileUp(prop) {
    const { currentState, setCurrentState, isEffectDone } = useContext(UserInputData);
    const { control, getValues, setValue, } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(false)
    const [resetValues, setResetValues] = useState(false)
    const [inputKey, setInputKey] = useState(0);
    const [activePost, setActivePost] = useState(false);
    const [file, setFile] = useState(false);
    const [fileShubetsu, setFileShubetsu] = useState(0);

    //start
    const inputFilesRef = useRef("");
    const authAxios = useAuthAxios();
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };
    //end

    /*useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])

    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(true)
        }
    }, [isEffectDone])

    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete) {
            setResetValues(true)
        }
    }, [isComplete])

    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };*/

    //func start
    //添付ファイル登録
    const filesUpload = () => {
        inputFilesRef.current.click();
    }

    const onImgsInputChange = (e) => {
        if (!e.target.files) return;

        let fileCountImage = 0
        let fileCountPdf = 0
        prop.attachedImage.forEach(attachedImageElement => {
            if (attachedImageElement.Type === prop.fileTypeId) {
                fileCountImage++
            }
        })

        prop.attachedPdf.forEach(attachedImageElement => {
            if (attachedImageElement.Type === prop.fileTypeId) {
                fileCountPdf++
            }
        })

        const curTarget = e.currentTarget.id;

        if (fileCountImage + fileCountPdf + e.target.files.length > prop.maxFileNum) {
            alert('添付ファイルは' + prop.maxFileNum + 'ファイルまで添付可能です。')
            setInputKey((prevKey) => prevKey + 1);
            return;
        }

        const attachFileExts = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'heic']

        for (let i = 0; i < e.target.files.length; i++) {
            if (!attachFileExts.includes(e.target.files[i].name.split('.').pop().toLowerCase())) {
                setInputKey((prevKey) => prevKey + 1);
                alert("下記のいずれかのファイルを選択して下さい。\n" + attachFileExts)
                return;
            }
            let fileNameLengthCounter = 0;
            for (let j = 0; j < e.target.files[i].name.length; j++) {
                if (e.target.files[i].name[j].match(/^[^ -~｡-ﾟ]/)) {
                    fileNameLengthCounter += 2
                } else {
                    fileNameLengthCounter += 1
                }
                if (fileNameLengthCounter > 60) {
                    alert("ファイル名は半角60文字、全角30文字以内に指定してください。\n\n超過したファイル名：" + e.target.files[i].name)
                    setInputKey((prevKey) => prevKey + 1);
                    return
                }
            }
        }

        prop.setProcessing(true);


        if (curTarget === 'attatchedZumen') {
            setFileShubetsu(0);
        } else if (curTarget === 'attatchedUchiawase') {
            setFileShubetsu(1);
        } else {
            setFileShubetsu(2);
        }
        setFile(e.target.files)
        setActivePost(true)

    };

    useEffect(() => {
        if (activePost) {
            async function postLoopFunction() {
                for (let i = 0; i < file.length; i++) {
                    const fileObject = file[i];
                    const body = new FormData();
                    body.append("fileName", fileObject.name);
                    body.append("file", fileObject);
                    await authAxios
                        .post('api/visitReport/' + prop.keyData.kojiCD + '/' + prop.keyData.rptShubetsu + '/' + prop.keyData.rptSeq + '/' + fileShubetsu
                            , body, { headers })
                        .then(response => {
                            if (response.status !== 200) {
                                alert("添付ファイル登録に失敗しました。", response.body);
                                prop.setProcessing(false);
                                setInputKey((prevKey) => prevKey + 1);
                            }
                        }).catch((response) => {
                            alert("添付ファイル登録に失敗しました。", response.body);
                            prop.setProcessing(false);
                            setInputKey((prevKey) => prevKey + 1);
                        })
                }
            }
            async function postConcurrently() {
                await postLoopFunction()
                prop.setUploadFlag(true)
                setInputKey((prevKey) => prevKey + 1);
                setActivePost(false)
            }
            postConcurrently()
        }
    }, [activePost])

    //添付画像削除確定
    const previewImgDeleteConfirm = () => {
        prop.setProcessing(true);
        authAxios
            .delete('api/visitReport/' + prop.keyData.kojiCD + '/' + prop.keyData.rptShubetsu + '/' + prop.keyData.rptSeq + '/' + prop.attachedImage[prop.prevDelIndex].ID + '/delete', { headers })
            .then(response => {
                if (response.status === 200) {
                    let prevFileArray = [...prop.attachedImage];
                    prevFileArray.splice(prop.prevDelIndex, 1);
                    prop.setAttachedImage(prevFileArray);
                    inputFilesRef.current.value = '';
                    prop.setPreviewImgDelDialog(false);
                    prop.setProcessing(false);
                }
            }).catch(response => {
                alert("添付ファイル取得に失敗しました。", response.body);
                prop.setProcessing(false);
            })
    }

    //添付PDF削除確定
    const previewPdfDeleteConfirm = () => {
        prop.setProcessing(true);
        authAxios
            .delete('api/visitReport/' + prop.keyData.kojiCD + '/' + prop.keyData.rptShubetsu + '/' + prop.keyData.rptSeq + '/' + prop.attachedPdf[prop.prevDelIndex].ID + '/delete', { headers })
            .then(response => {
                if (response.status === 200) {
                    let prevArray = [...prop.attachedPdf];
                    prevArray.splice(prop.prevDelIndex, 1);
                    prop.setAttachedPdf(prevArray);
                    inputFilesRef.current.value = '';
                    prop.setPreviewPdfDelDialog(false);
                    prop.setProcessing(false);
                }
            }).catch(response => {
                alert("添付ファイル取得に失敗しました。", response.body);
                prop.setProcessing(false);
            })
    }
    //func end

    return (
        <React.Fragment>
            <Grid container direction='row' sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Grid>
                    <NomalButton variant="contained" size="large" onClick={filesUpload} disabled={!prop.canEdit}
                        sx={{ ml: 2, mr: 2, py: 1.5, px: 4, fontSize: '1.2rem' }}>
                        <DescriptionIcon sx={{ mr: 2, fontSize: '2rem' }} />ファイルを選択</NomalButton>
                </Grid>
                <Grid container
                    sx={{
                        height: 'auto',
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                    }}>
                    <input
                        type="file"
                        hidden
                        multiple
                        ref={inputFilesRef}
                        accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,.heic"
                        onChange={onImgsInputChange}
                        id={prop.elementId} />
                    <ImageList sx={{ width: '100%', height: 'auto' }} cols={5} rowHeight={220}>
                        {prop.attachedImage.map((item, index) => (
                            (item.Type === prop.fileTypeId) ?
                                <ImageListItem style={{ position: "relative", }} key={index}>
                                    <img
                                        src={item.src}
                                        alt=""
                                        loading="eager"
                                        onClick={() => prop.showPreviewImg(item, index)}
                                        style={{
                                            width: "220px",
                                            height: "220px",
                                            objectfit: "cover"
                                        }}
                                    />
                                    {prop.canEdit &&
                                        <IconButton
                                            sx={{
                                                bgcolor: alpha("#C0C0C0", 0.8), fontSize: '2rem', px: 2, py: 2,
                                                "&:hover": {
                                                    bgcolor: alpha("#a9a9a9", 0.5)
                                                },
                                            }}
                                            style={{
                                                position: "absolute",
                                                left: '62%',
                                                top: '0%',
                                                borderRadius: "50px",
                                                zIndex: 999,

                                            }}
                                            onClick={() => prop.previewImgDeleteClick(index)}
                                        >
                                            <DeleteForeverIcon
                                                sx={{ fontSize: '3rem', color: '#d32f2f' }} />
                                        </IconButton>
                                    }
                                </ImageListItem>
                                : ""
                        ))}
                        {prop.attachedPdf?.map((item, index) => (
                            (item.Type === prop.fileTypeId) ?
                                <Grid style={{ position: "relative", }} key={index}>
                                    < PictureAsPdfIcon
                                        sx={{ fontSize: "180px", color: "#d32f2f" }}
                                        onClick={() => prop.previewPdfOnClick(index)}
                                    />
                                    {item.Name.length < 12 ?
                                        < Typography sx={{ px: 2 }} >{item.Name}</Typography>
                                        :

                                        < Typography sx={{ px: 2 }} >{item.Name?.slice(0, 11) + '...'}</Typography>
                                    }
                                    <Button
                                        sx={{
                                            bgcolor: alpha("#C0C0C0", 0.8), fontSize: '2rem', px: 2, py: 2,
                                            "&:hover": {
                                                bgcolor: alpha("#a9a9a9", 0.5) 
                                            },
                                        }}
                                        style={{
                                            position: "absolute",
                                            left: '62%',
                                            top: '0%',
                                            borderRadius: "50px",
                                            zIndex: 999
                                        }}
                                        onClick={() => prop.previewPdfDeleteClick(index)}>
                                        <DeleteForeverIcon sx={{ fontSize: '3rem', color: '#d32f2f' }} />
                                    </Button>
                                </Grid>
                                : ""
                        ))}
                    </ImageList>
                </Grid>
            </Grid>
            <InspectionPreviewDialog
                src={prop.attachedImage.map((list) => list.src)}
                index={prop.previewImgIndex}
                open={prop.previewImgDialog}
                cancelClick={prop.previewImgCancelClick}
            />

            <InspectionDeleteDialog
                contentType={1}
                name={prop.attachedImage[prop.prevDelIndex]?.Name}
                src={prop.attachedImage[prop.prevDelIndex]?.src}
                open={prop.previewImgDelDialog}
                cancelClick={prop.previewCancelBack}
                deleteClick={previewImgDeleteConfirm} />

            <InspectionDeleteDialog
                contentType={2}
                name={prop.attachedPdf[prop.prevDelIndex]?.Name}
                open={prop.previewPdfDelDialog}
                cancelClick={prop.previewCancelBack}
                deleteClick={previewPdfDeleteConfirm} />
        </React.Fragment>
    )
}
